<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  status: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();

// Message#status enum (app/models/message.rb): sent, delivered, read, failed.
const STATUS_CONFIG = {
  sent: { icon: 'i-lucide-send', class: 'bg-n-slate-3 text-n-slate-11' },
  delivered: {
    icon: 'i-lucide-check-check',
    class: 'bg-n-teal-3 text-n-teal-11',
  },
  read: { icon: 'i-lucide-eye', class: 'bg-n-blue-3 text-n-blue-11' },
  failed: {
    icon: 'i-lucide-circle-alert',
    class: 'bg-n-ruby-3 text-n-ruby-11',
  },
};

const config = computed(
  () => STATUS_CONFIG[props.status] || STATUS_CONFIG.sent
);
</script>

<template>
  <span
    class="inline-flex items-center justify-center w-fit gap-1.5 h-6 px-2 rounded-md text-label-small shrink-0"
    :class="config.class"
  >
    <Icon :icon="config.icon" class="size-3 flex-shrink-0" />
    <span class="truncate">
      {{ t(`MESSAGE_LOGS_PAGE.STATUS.${status.toUpperCase()}`) }}
    </span>
  </span>
</template>
